module.exports = __webpack_public_path__ + "static/media/stanford_logo.da0e7c80.png";